export default __webpack_public_path__ + "static/media/shipping-fast-white.ea66263c.svg";